import React from 'react';
import { ViewProduct } from '../../models/ViewProduct.model';
import { CollectionHeader } from './CollectionHeader';
import { useProductAssets } from '../../hooks/useProductAssets';
import { Stars } from '../../components/Stars';
import { useProductRating } from '../../hooks/useProductRating';
import { ViewVariant } from '../../models/ShopifyVariant.model';
import { ProductPerks } from '../../components/ProductPerks';
import { Link } from '../../root/components/Link';
import { useRecoilValue } from 'recoil';
import { pageContextState } from '../../recoil/atoms';

interface Props {
  hoverProduct: ViewProduct;
  hoverVariant: ViewVariant;
}

export const CollectionHoverHeader: React.FC<Props> = ({ hoverProduct, hoverVariant }) => {
  const rating = useProductRating(hoverProduct);
  const photos = useProductAssets(hoverProduct);
  const filteredModelPhotos = photos.modelPhotos.filter(({ color }) => color === hoverVariant?.color);
  // skip the first photo as that will be shown on the collection card hover
  const hoverImages = filteredModelPhotos.slice(1, 5).map((i) => i.src);
  const pageContext = useRecoilValue(pageContextState);

  return (
    <div style={{ position: 'relative', display: 'contents' }}>
      <CollectionHeader title={hoverProduct.title} description={hoverProduct.coreFeatures} images={hoverImages}>
        <Link
          dataTrackLabel="Collections hover header"
          dataTrackLocation={pageContext}
          href={`/products/${hoverProduct.handle}?color=${hoverVariant.color}`}
          buttonType="ghost"
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Stars amount={rating.rating} />
            <span>({rating.totalReviews || '-'})</span>
          </div>
          <ProductPerks product={hoverProduct} />
        </Link>
      </CollectionHeader>
    </div>
  );
};

export default CollectionHoverHeader;
